import { shallowEqual, useSelector } from "react-redux";

import { RootState } from "../store/configureStore";

export function useShallowEqualSelector<TResult>(selector: (store: RootState) => TResult): TResult {
  return useSelector(selector, shallowEqual);
}
